<header class="presentation-header">
  @if (!isMobile) {
    <img class="logo" src="assets/images/logos/scoot_logo_reverse.png" alt="Scoot" />
  }
</header>
